<template>
  <div class="section-profile">
    <b-modal
      size="lg"
      id="modalCollaborators"
      header-bg-variant="info"
      header-text-variant="light"
      title="Usuários subordinados"
      ref="modalCollaborators"
      hide-footer
      scrollable
    >
      <div
        class='modal_font_size ml-3'
           v-if='user && user.subordinateUsers && user.subordinateUsers.collaborators && user.subordinateUsers.collaborators.length > 0'
      >
        <ol class='ml-3'>
          <li
            class='mb-2'
            v-for="(collaborate, index) in user.subordinateUsers.collaborators"
            :key="`_${index}_`"
          >
            <strong>E-mail:</strong> {{collaborate && collaborate.username ? collaborate.username : '-'}}
            <ul class='ml-3' style='list-style-type: disc;' v-if='collaborate && collaborate.plan && collaborate.plan._id'>
              <li>
                <span><strong>Data de criação do plano:</strong> {{collaborate && collaborate.plan && collaborate.plan.createdAt ? formatDate(collaborate.plan.createdAt) : '-'}}</span><br/>
              </li>
              <li>
                <span><strong>Data de vencimento do plano:</strong> {{collaborate && collaborate.plan && collaborate.plan.dueDate ? formatDateDueDate(collaborate.plan.dueDate) : '-'}}</span>
              </li>
            </ul>

            <section class='ml-4 mb-4 mt-0' v-if='collaborate && collaborate.collaboratorhistorics && collaborate.collaboratorhistorics.length > 0'>
              <hr/>
              <strong>Histórico:</strong>
              <ol class='ml-3'>

                <li
                  v-for='(historics, i) in collaborate.collaboratorhistorics'
                  :key="`__${i}__`"
                  class='mb-1'
                >
                  <span>
                    <strong>Data: </strong>{{historics && historics.createdAt ? formatDate(historics.createdAt) : '-'}}
                  </span><br/>
                  <span>
                    <strong>Descrição: </strong>{{historics && historics.description ? historics.description : ''}}
                  </span>
                </li>
              </ol>
            </section>
          </li>
        </ol>

        <section class='mb-4 mt-2' v-if='user && user.subordinateCollaboratorHistoric && user.subordinateCollaboratorHistoric.length > 0'>
          <hr/>
          <strong>Histórico completo:</strong><br/>
          <ol class='ml-3 mt-1'>
            <li
              v-for='historics in user.subordinateCollaboratorHistoric'
              :key='historics._id'
              class='mb-2'
            >
              <span>
                <strong>Data: </strong>{{ historics && historics.createdAt ? formatDate(historics.createdAt) : '-'}}
              </span><br/>

              <span>
                <strong>Descrição: </strong>{{historics && historics.description ? historics.description : '-'}}
              </span><br/>

              <span>
                <strong>Usuário: </strong>{{historics && historics.collaborator && historics.collaborator.username ? historics.collaborator.username : ''}}
              </span>
            </li>
          </ol>
        </section>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      id="modalInvitationCollaborator"
      header-bg-variant="info"
      header-text-variant="light"
      title="Convites pendentes"
      ref="modalInvitationCollaborator"
      hide-footer
      scrollable
    >
      <div
        class='modal_font_size'
        v-if='user && user.invitationCollaborator && user.invitationCollaborator.length > 0'
      >
        <ol class='ml-3'>
          <li
            class='mb-2'
            v-for="invitation in user.invitationCollaborator"
            :key='invitation._id'
          >
            <strong>E-mail:</strong> {{invitation.collaboratorEmail}}
            <ul class='ml-3' style='list-style-type: disc;'>
              <li>
                <span><strong>Data de envio do convite:</strong> {{formatDate(invitation.createdAt)}}</span><br/>
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      id="modalTermsAndPolicies"
      header-bg-variant="info"
      header-text-variant="light"
      title="Histórico de aceites"
      ref="modalTermsAndPolicies"
      hide-footer
      scrollable
    >
      <div class="terms-modal">
        <div
          class="terms-group"
          v-for="group in visibleTermsAndPoliciesGroups"
          :key="group.key"
        >
          <b-list-group v-if="group.history.length">
            <b-list-group-item
              v-for="(item, index) in group.history"
              :key="`${group.key}_history_${index}`"
            >
              <dl class="field-list field-list--compact">
                <dt>{{ group.acceptedAtLabel }}</dt>
                <dd class="num" :class="{ empty: !item.acceptedAt }">{{ item.acceptedAt ? formatDate(item.acceptedAt) : '—' }}</dd>

                <dt>{{ group.attachedLabel }}</dt>
                <dd class="num" :class="{ empty: !item.documentPublishedAt }">{{ item.documentPublishedAt ? formatDate(item.documentPublishedAt) : '—' }}</dd>

                <dt>Documento</dt>
                <dd v-if="item.documentUrl">
                  <a class="doc-link" :href="item.documentUrl" target="_blank" rel="noopener">
                    Ver {{ item.documentName ? item.documentName : group.fallbackDocName }}
                  </a>
                </dd>
                <dd v-else class="empty">—</dd>
              </dl>
            </b-list-group-item>
          </b-list-group>
          <p v-else class="empty terms-group__empty">Ainda não há histórico de aceites anteriores para {{ group.title }}.</p>
        </div>
      </div>
    </b-modal>

    <b-card no-body class="profile-card" v-if='user && user.profile'>
      <header class="profile-header">
        <div class="identity">
          <div class="avatar">{{ initials }}</div>
          <div class="identity-text">
            <div class="eyebrow">Dados pessoais</div>
            <div class="name">{{ name || '—' }}</div>
            <a v-if="user.username" class="email" :href="`mailto:${user.username}`">{{ user.username }}</a>
          </div>
        </div>

        <div class="status-chips">
          <span v-if="user.confirmed" class="chip chip--positive">Conta ativada</span>
          <span v-if="user.termsConfirmation" class="chip chip--positive">Termos aceitos</span>
          <span v-if="user.privacyPolicyConfirmation" class="chip chip--positive">Política de privacidade aceita</span>
          <span v-if="user.createdAt" class="chip chip--neutral">Cadastro {{ formatShortDate(user.createdAt) }}</span>
        </div>
      </header>

      <div class="profile-body">
        <section class="profile-section">
          <h3 class="section-title">Identificação</h3>
          <dl class="field-list">
            <dt>Nome</dt>
            <dd class="strong" :class="{ empty: !name }">{{ name || '—' }}</dd>

            <dt>Email</dt>
            <dd v-if="user.username"><a :href="`mailto:${user.username}`">{{ user.username }}</a></dd>
            <dd v-else class="empty">—</dd>

            <dt>Telefone</dt>
            <dd class="num" :class="{ empty: !phone }">{{ phone || '—' }}</dd>

            <dt>Telefone comercial</dt>
            <dd class="num" :class="{ empty: !businessPhone }">{{ businessPhone || '—' }}</dd>

            <dt>CPF</dt>
            <dd class="num" :class="{ empty: !cpfFormatted }">{{ cpfFormatted || '—' }}</dd>

            <dt>CNPJ</dt>
            <dd class="num" :class="{ empty: !cnpjFormatted }">{{ cnpjFormatted || '—' }}</dd>

            <dt>Data do cadastro</dt>
            <dd class="num" :class="{ empty: !user.createdAt }">{{ user.createdAt ? formatDate(user.createdAt) : '—' }}</dd>
          </dl>
        </section>

        <section class="profile-section">
          <h3 class="section-title">Conta e segurança</h3>
          <dl class="field-list">
            <dt>A conta foi ativada?</dt>
            <dd :class="user.confirmed ? 'yes' : 'empty'">{{ user.confirmed ? 'Sim' : 'Não' }}</dd>

            <dt>Quando a conta foi ativada?</dt>
            <dd class="num" :class="{ empty: !user.confirmationDate }">{{ user.confirmationDate ? formatDate(user.confirmationDate) : '—' }}</dd>

            <dt>Dados de perfil preenchidos e atualizados?</dt>
            <dd :class="checkProfileIsFilled(user) === 'Sim' ? 'yes' : 'empty'">{{ checkProfileIsFilled(user) }}</dd>

            <dt>Não solicitar autenticação em dois fatores até qual data?</dt>
            <dd class="num" :class="{ empty: !user.twoFactorAuthenticationReleaseDeadline }">{{ user.twoFactorAuthenticationReleaseDeadline ? formatDate(user.twoFactorAuthenticationReleaseDeadline) : '—' }}</dd>

            <dt>Tempo extra de acesso</dt>
            <dd class="num">{{ user.endDateExtraAccessTime ? formatQuantityDaysExtraAccess(user.endDateExtraAccessTime) : 0 }} dia(s)</dd>
          </dl>
        </section>

        <section class="profile-section">
          <h3 class="section-title">Termos e políticas</h3>
          <div class="contract-cards">
            <div class="contract-card">
              <div class="contract-card__head">
                <span class="contract-card__name">Termos de uso</span>
                <div class="contract-card__status">
                  <span :class="user.termsConfirmation ? 'contract-card__state' : 'contract-card__state contract-card__state--off'">
                    {{ user.termsConfirmation ? 'Aceito' : 'Não aceito' }}
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-success"
                    class="terms-history-button"
                    @click="showModalTermsAndPolicies('terms')"
                  >
                    Ver histórico de aceites
                  </b-button>
                </div>
              </div>
              <dl class="field-list field-list--compact">
                <dt>Aceito em</dt>
                <dd class="num" :class="{ empty: !user.dataAcceptedTermsConfirmation }">{{ user.dataAcceptedTermsConfirmation ? formatDate(user.dataAcceptedTermsConfirmation) : '—' }}</dd>

                <dt>Anexado ao sistema</dt>
                <dd class="num" :class="{ empty: !user.termsOfUseDate }">{{ user.termsOfUseDate ? formatDate(user.termsOfUseDate) : '—' }}</dd>

                <dt>Documento</dt>
                <dd v-if="user.termsOfUseUrl">
                  <a class="doc-link" :href="user.termsOfUseUrl" target="_blank" rel="noopener">
                    Ver {{ user.termsOfUseName ? user.termsOfUseName : 'Termos de uso' }}
                  </a>
                </dd>
                <dd v-else class="empty">—</dd>
              </dl>
            </div>

            <div class="contract-card">
              <div class="contract-card__head">
                <span class="contract-card__name">Política de privacidade</span>
                <div class="contract-card__status">
                  <span :class="user.privacyPolicyConfirmation ? 'contract-card__state' : 'contract-card__state contract-card__state--off'">
                    {{ user.privacyPolicyConfirmation ? 'Aceita' : 'Não aceita' }}
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-success"
                    class="terms-history-button"
                    @click="showModalTermsAndPolicies('privacy')"
                  >
                    Ver histórico de aceites
                  </b-button>
                </div>
              </div>
              <dl class="field-list field-list--compact">
                <dt>Aceita em</dt>
                <dd class="num" :class="{ empty: !user.dataAcceptedPrivacyPolicyConfirmation }">{{ user.dataAcceptedPrivacyPolicyConfirmation ? formatDate(user.dataAcceptedPrivacyPolicyConfirmation) : '—' }}</dd>

                <dt>Anexada ao sistema</dt>
                <dd class="num" :class="{ empty: !user.privacyPolicyDate }">{{ user.privacyPolicyDate ? formatDate(user.privacyPolicyDate) : '—' }}</dd>

                <dt>Documento</dt>
                <dd v-if="user.privacyPolicyUrl">
                  <a class="doc-link" :href="user.privacyPolicyUrl" target="_blank" rel="noopener">
                    Ver {{ user.privacyPolicyName ? user.privacyPolicyName : 'Política de privacidade' }}
                  </a>
                </dd>
                <dd v-else class="empty">—</dd>
              </dl>
            </div>
          </div>
        </section>

        <section class="profile-section">
          <h3 class="section-title">Usuários e acessos</h3>
          <div class="count-cards">
            <div class="count-card">
              <div class="count-card__value" :class="{ empty: !subordinatesCount }">{{ subordinatesCount || '—' }}</div>
              <div class="count-card__label">Usuários subordinados</div>
              <b-link v-if="subordinatesCount" class="count-card__link" @click="showModalCollaborators()">Ver subordinados</b-link>
            </div>

            <div class="count-card">
              <div class="count-card__value" :class="{ empty: !invitationsCount }">{{ invitationsCount || '—' }}</div>
              <div class="count-card__label">Convites pendentes</div>
              <b-link v-if="invitationsCount" class="count-card__link" @click="showModalInvitationCollaborator()">Ver convites</b-link>
            </div>

            <div class="count-card">
              <div class="count-card__value" :class="{ empty: purchasedAccess === null }">{{ purchasedAccess === null ? '—' : purchasedAccess }}</div>
              <div class="count-card__label">Acessos comprados</div>
            </div>

            <div class="count-card">
              <div class="count-card__value" :class="{ empty: remainingAccess === null }">{{ remainingAccess === null ? '—' : remainingAccess }}</div>
              <div class="count-card__label">Acessos restantes</div>
            </div>
          </div>
          <p v-if="!hasAccessData" class="count-note">Sem dados de assinatura registrados para este usuário.</p>
        </section>
      </div>
    </b-card>
  </div>
</template>

<script>
import format from 'date-fns/esm/format/index'
import moment from 'moment'
import {profileIsFilled} from '../../utils/checkProfileIsFilled'

export default {
  name: 'SectionProfile',
  props: {
    user: { type: Object, required: true }
  },
  data() {
    return {
      selectedTermsType: null
    }
  },
  computed:{
    userCurrent() {
      return this.$store.getters['user/current']
    },
    initials() {
      const name = (this.user && this.user.profile && this.user.profile.name) || ''
      const parts = name.trim().split(/\s+/).filter(Boolean)
      if (parts.length === 0) return '—'
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
    },
    name() {
      return (this.user && this.user.profile && this.user.profile.name) || null
    },
    phone() {
      return (this.user && this.user.profile && this.user.profile.phone) || null
    },
    businessPhone() {
      return (this.user && this.user.profile && this.user.profile.company && this.user.profile.company.phone) || null
    },
    cpfFormatted() {
      const cpf = this.user && this.user.profile && this.user.profile.cpf
      return cpf && cpf.length >= 11 ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : null
    },
    cnpjFormatted() {
      const cnpj = this.user && this.user.profile && this.user.profile.company && this.user.profile.company.cnpj
      return cnpj && cnpj.length >= 14 ? cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') : null
    },
    subordinatesCount() {
      return (this.user && this.user.subordinateUsers && this.user.subordinateUsers.collaborators && this.user.subordinateUsers.collaborators.length) || 0
    },
    invitationsCount() {
      return (this.user && this.user.invitationCollaborator && this.user.invitationCollaborator.length) || 0
    },
    purchasedAccess() {
      const access = this.user && this.user.accessCollaborator
      if (access && access.length > 0) return access.reduce((acumulator, item) => acumulator + item.amountPurchased, 0)
      return null
    },
    remainingAccess() {
      const access = this.user && this.user.accessCollaborator
      if (access && access.length > 0) return access.reduce((acumulator, item) => acumulator + item.remainingAmount, 0)
      return null
    },
    hasAccessData() {
      return !!(this.user && this.user.accessCollaborator && this.user.accessCollaborator.length > 0)
    },
    termsHistory() {
      return (this.user && this.user.termsOfUseAcceptanceHistory) || []
    },
    privacyHistory() {
      return (this.user && this.user.privacyPolicyAcceptanceHistory) || []
    },
    termsAndPoliciesGroups() {
      return [
        {
          key: 'terms',
          title: 'Termos de uso',
          acceptedAtLabel: 'Aceito em',
          attachedLabel: 'Anexado ao sistema',
          fallbackDocName: 'Termos de uso',
          history: this.termsHistory,
        },
        {
          key: 'privacy',
          title: 'Política de privacidade',
          acceptedAtLabel: 'Aceita em',
          attachedLabel: 'Anexada ao sistema',
          fallbackDocName: 'Política de privacidade',
          history: this.privacyHistory,
        },
      ]
    },
    visibleTermsAndPoliciesGroups() {
      return this.termsAndPoliciesGroups.filter((group) => group.key === this.selectedTermsType)
    },
  },
  methods: {
    formatDateDueDate(date) {
      const dueDate = new Date(date)
      return moment(new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate(), 23, 59, 59)).format('DD/MM/YYYY HH:mm:ss')
    },
    checkProfileIsFilled(user) {
      return profileIsFilled(user) ? 'Sim': 'Não'
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    },
    formatShortDate(date) {
      return format(new Date(date), 'dd/MM/yyyy')
    },
    formatQuantityDaysExtraAccess(date) {
      if(this.user.plan && this.user.plan.originalDueDate){
        this.user.plan.dueDate = this.user.plan.originalDueDate
      }
      if(moment(new Date(date)).isSameOrAfter(this.userCurrent.currentDate)) {
        let quantityDaysExtraAccess = parseInt(moment.duration(moment(new Date(date)).diff(moment(new Date(this.userCurrent.currentDate)))).asDays())
        if (this.user.plan && this.user.plan.status === 'paid') {
          if (moment(new Date(date)).isSameOrAfter(new Date(this.user.plan.dueDate))) {
            quantityDaysExtraAccess = Math.ceil(moment.duration(moment(new Date(date)).diff(moment(new Date(this.user.plan.dueDate)))).asDays())
          } else if (moment(new Date(date)).isSameOrAfter(new Date(this.userCurrent.currentDate))) {
            quantityDaysExtraAccess = Math.ceil(moment.duration(moment(new Date(date)).diff(moment(new Date(this.userCurrent.currentDate)))).asDays())
          }
        }
        return quantityDaysExtraAccess > 0 ? quantityDaysExtraAccess : 1
      }
      return 0
    },
    showModalCollaborators(){
      this.$refs.modalCollaborators.show()
    },
    showModalInvitationCollaborator(){
      this.$refs.modalInvitationCollaborator.show()
    },
    showModalTermsAndPolicies(type){
      this.selectedTermsType = type
      this.$refs.modalTermsAndPolicies.show()
    }

  }
}
</script>

<style lang="scss" scoped>
$green: #28a745;
$green-text: #1e7e34;
$ink: #292929;
$ink-2: #4a4f54;
$muted: #8a8f94;
$border: #e6e8ea;
$neutral-bg: #f5f6f7;

.section-profile {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.profile-card {
  border: 1px solid $border;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(40, 167, 69, 0.1);
  overflow: hidden;
}

.profile-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  padding: 16px 20px;
  border-bottom: 1px solid $border;

  .identity {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .avatar {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 6px;
    background: $green;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  .identity-text {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
  }

  .eyebrow {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $ink-2;
  }

  .name {
    font-size: 19px;
    font-weight: 600;
    color: $ink;
    line-height: 1.2;
    word-break: break-word;
  }

  .email {
    font-size: 13px;
    word-break: break-word;
  }
}

.status-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding-top: 2px;

  .chip {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;

    &--positive {
      background: rgba(40, 167, 69, 0.12);
      color: $green-text;
    }

    &--neutral {
      background: $neutral-bg;
      color: $ink-2;
    }
  }
}

.profile-body {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.profile-section {
  padding: 12px 16px;

  &:nth-child(1),
  &:nth-child(2) {
    border-bottom: 1px solid $border;
  }

  &:nth-child(odd) {
    border-right: 1px solid $border;
  }
}

.section-title {
  margin: 0 0 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: $green-text;
}

.field-list {
  margin: 0;
  display: grid;
  grid-template-columns: minmax(150px, 42%) 1fr;
  row-gap: 3px;
  column-gap: 14px;
  font-size: 13px;

  &--compact {
    grid-template-columns: minmax(120px, 45%) 1fr;
    row-gap: 2px;
    font-size: 12.5px;
  }

  dt {
    color: $ink-2;
  }

  dd {
    margin: 0;
    color: $ink;
    word-break: break-word;
  }

  .strong {
    font-weight: 600;
  }

  .num {
    font-variant-numeric: tabular-nums;
  }

  .yes {
    color: $green-text;
    font-weight: 600;
  }

  .empty {
    color: $muted;
  }
}

.contract-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contract-card {
  border: 1px solid $border;
  border-radius: 8px;
  padding: 9px 11px;

  &__head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 6px;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    color: $ink;
  }

  &__state {
    font-size: 13px;
    font-weight: 600;
    color: $green-text;

    &--off {
      color: $muted;
    }
  }

  .doc-link {
    font-weight: 600;
  }
}

.contract-card__status {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.terms-history-button {
  font-weight: 600;
  white-space: nowrap;
}

.terms-modal {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.terms-group {
  &__empty {
    margin: 0;
    font-size: 12.5px;
  }

  .doc-link {
    font-weight: 600;
  }
}

.count-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.count-card {
  border: 1px solid $border;
  border-radius: 8px;
  padding: 7px 10px;
  display: flex;
  flex-direction: column;
  gap: 0;

  &__value {
    font-size: 18px;
    font-weight: 200;
    color: $ink;
    line-height: 1;
    font-variant-numeric: tabular-nums;

    &.empty {
      color: $muted;
    }
  }

  &__label {
    font-size: 12px;
    color: $ink-2;
    line-height: 1.25;
  }

  &__link {
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }
}

.count-note {
  margin: 10px 0 0;
  font-size: 12px;
  color: $muted;
  line-height: 1.4;
}

@media (max-width: 900px) {
  .profile-body {
    grid-template-columns: 1fr;
  }

  .profile-section {
    border-right: none !important;
    border-bottom: 1px solid $border;

    &:last-child {
      border-bottom: none;
    }
  }

  .field-list {
    grid-template-columns: 1fr;
    row-gap: 2px;

    dt {
      margin-top: 6px;
    }
  }
}
</style>
